var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bx-smile.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z",
    fill: "#70808F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.829 14.8264C14.4635 15.1907 14.0317 15.4819 13.557 15.6844C12.7023 16.0452 11.7488 16.0979 10.8595 15.8334C9.97028 15.5689 9.20055 15.0037 8.68199 14.2344L7.02399 15.3534C7.45642 15.9915 8.00658 16.5413 8.64499 16.9734C9.29464 17.4127 10.0246 17.7196 10.793 17.8764C11.5898 18.0389 12.4112 18.0389 13.208 17.8764C13.9763 17.7193 14.7062 17.4125 15.356 16.9734C15.669 16.7614 15.968 16.5154 16.242 16.2424C16.514 15.9714 16.762 15.6714 16.976 15.3534L15.318 14.2344C15.1743 14.4469 15.0105 14.6451 14.829 14.8264Z",
    fill: "#70808F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.5 12C9.32843 12 10 11.3284 10 10.5C10 9.67157 9.32843 9 8.5 9C7.67157 9 7 9.67157 7 10.5C7 11.3284 7.67157 12 8.5 12Z",
    fill: "#70808F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.493 11.986C16.3176 11.986 16.986 11.3176 16.986 10.493C16.986 9.66844 16.3176 9 15.493 9C14.6684 9 14 9.66844 14 10.493C14 11.3176 14.6684 11.986 15.493 11.986Z",
    fill: "#70808F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxSmile);
export default __webpack_public_path__ + "static/media/bx-smile.29c1cc09cc4e97d30d543bcc6ef8ed09.svg";
export { ForwardRef as ReactComponent };